import { Component, OnInit, AfterViewChecked } from "@angular/core";
import { EmpresaService, Empresa } from "../../shared/services/empresa.service";
const Swal = require("sweetalert2");

@Component({
  selector: "app-empresas",
  templateUrl: "./empresas.component.html",
  styleUrls: ["./empresas.component.scss"],
})
export class EmpresasComponent implements OnInit, AfterViewChecked {
  public empresas: Empresa[] = [];
  public loading: boolean = false;
  public currentPage: number = 1;
  public totalPages: number = 1;
  public totalItems: number = 0;
  public filtros: any = {
    status: "",
    uf: "",
  };
  public mostrarFiltros: boolean = false;
  public ufs: Array<{ sigla: string; nome: string }> = [
    { sigla: "AC", nome: "Acre" },
    { sigla: "AL", nome: "Alagoas" },
    { sigla: "AP", nome: "Amapá" },
    { sigla: "AM", nome: "Amazonas" },
    { sigla: "BA", nome: "Bahia" },
    { sigla: "CE", nome: "Ceará" },
    { sigla: "DF", nome: "Distrito Federal" },
    { sigla: "ES", nome: "Espírito Santo" },
    { sigla: "GO", nome: "Goiás" },
    { sigla: "MA", nome: "Maranhão" },
    { sigla: "MT", nome: "Mato Grosso" },
    { sigla: "MS", nome: "Mato Grosso do Sul" },
    { sigla: "MG", nome: "Minas Gerais" },
    { sigla: "PA", nome: "Pará" },
    { sigla: "PB", nome: "Paraíba" },
    { sigla: "PR", nome: "Paraná" },
    { sigla: "PE", nome: "Pernambuco" },
    { sigla: "PI", nome: "Piauí" },
    { sigla: "RJ", nome: "Rio de Janeiro" },
    { sigla: "RN", nome: "Rio Grande do Norte" },
    { sigla: "RS", nome: "Rio Grande do Sul" },
    { sigla: "RO", nome: "Rondônia" },
    { sigla: "RR", nome: "Roraima" },
    { sigla: "SC", nome: "Santa Catarina" },
    { sigla: "SP", nome: "São Paulo" },
    { sigla: "SE", nome: "Sergipe" },
    { sigla: "TO", nome: "Tocantins" },
  ];
  private shouldScrollToTop = false;
  empresaSelecionada: any = null;
  modalAberta: boolean = false;
  modalEditarStatusAberta = false;
  empresaParaEditar: any = null;

  constructor(private empresaService: EmpresaService) {}

  ngOnInit() {
    this.carregarEmpresas();
  }

  ngAfterViewChecked() {
    if (this.shouldScrollToTop) {
      const cardElement = document.querySelector(".card");
      if (cardElement) {
        cardElement.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
        this.shouldScrollToTop = false;
      }
    }
  }

  carregarEmpresas(page: number = 1) {
    this.loading = true;
    this.currentPage = page;
    this.empresaService.listarDoRepresentante(page, this.filtros).subscribe({
      next: (res) => {
        this.empresas = res.data || [];
        this.totalPages = res.last_page || 1;
        this.totalItems = res.total || 0;
        this.loading = false;
      },
      error: (err) => {
        if (err.status === 401 || err.status === 403) {
          this.showAlert(
            "error",
            "Sessão expirada. Redirecionando para login..."
          );
        } else {
          this.showAlert(
            "error",
            "Erro ao carregar empresas. Tente novamente."
          );
        }
        this.loading = false;
      },
    });
  }

  onPageChange(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.carregarEmpresas(page);
      this.shouldScrollToTop = true;
    }
  }

  getPageNumbers(): number[] {
    const pages: number[] = [];
    const maxVisible = 5;
    let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
    let end = Math.min(this.totalPages, start + maxVisible - 1);
    if (end - start + 1 < maxVisible) {
      start = Math.max(1, end - maxVisible + 1);
    }
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  }

  aplicarFiltros() {
    this.currentPage = 1;
    this.carregarEmpresas();
    this.mostrarFiltros = false;
    this.shouldScrollToTop = true;
  }

  limparFiltros() {
    this.filtros = {
      status: "",
      uf: "",
    };
    this.currentPage = 1;
    this.carregarEmpresas();
    this.mostrarFiltros = false;
    this.shouldScrollToTop = true;
  }

  toggleFiltros() {
    this.mostrarFiltros = !this.mostrarFiltros;
  }

  abrirDetalhes(empresa: any) {
    this.empresaSelecionada = empresa;
    this.modalAberta = true;
  }

  fecharModal() {
    this.modalAberta = false;
    this.empresaSelecionada = null;
  }

  abrirModalEditarStatus(empresa: any) {
    this.empresaParaEditar = empresa;
    this.modalEditarStatusAberta = true;
  }

  fecharModalEditarStatus() {
    this.modalEditarStatusAberta = false;
    this.empresaParaEditar = null;
  }

  salvarStatusEmpresa(novoStatus: number) {
    this.empresaService
      .updateStatusEmpresa(this.empresaParaEditar.id, novoStatus)
      .subscribe({
        next: () => {
          const idx = this.empresas.findIndex(
            (e) => e.id === this.empresaParaEditar.id
          );
          if (idx !== -1) {
            this.empresas[idx] = {
              ...this.empresas[idx],
              status: novoStatus,
            };

            this.empresaParaEditar = this.empresas[idx];
          }
          this.fecharModalEditarStatus();
          setTimeout(() => {
            Swal.fire({
              toast: true,
              position: "top-end",
              icon: "success",
              title: "Status atualizado com sucesso!",
              showConfirmButton: false,
              timer: 3000,
              customClass: { popup: "swal-toast-zindex" },
            });
          }, 100);
        },
        error: () => {
          this.fecharModalEditarStatus();
          setTimeout(() => {
            Swal.fire({
              toast: true,
              position: "top-end",
              icon: "error",
              title: "Erro ao atualizar status. Tente novamente.",
              showConfirmButton: false,
              timer: 3000,
              customClass: { popup: "swal-toast-zindex" },
            });
          }, 100);
        },
      });
  }

  showAlert(
    icon: "success" | "info" | "error",
    title: string,
    description?: string
  ) {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
    Toast.fire({
      icon: icon,
      title: title,
      text: description,
    });
  }
}
